import {
  addColumns,
  createTable,
  schemaMigrations,
} from "@nozbe/watermelondb/Schema/migrations";
import { baseColumns, syncMetaColumns } from "./schema";

export default schemaMigrations({
  migrations: [
    {
      toVersion: 2,
      steps: [
        createTable({
          name: "inventory_movement_items",
          columns: [
            { name: "inventory_movement_id", type: "string" },
            { name: "status", type: "string", isOptional: true },
            { name: "counted", type: "number", isOptional: true },
            { name: "stock_code", type: "string", isOptional: true },
            { name: "product_id", type: "string", isOptional: false },
            { name: "initial_expected", type: "number", isOptional: true },
            { name: "expected", type: "number", isOptional: true },
            { name: "cost", type: "number" },
            { name: "manual", type: "boolean" },
            ...baseColumns,
          ],
        }),
        createTable({
          name: "inventory_movements",
          columns: [
            { name: "name", type: "string", isOptional: true },
            { name: "status", type: "string" },
            {
              name: "inventory_movement_date",
              type: "number",
              isOptional: true,
            },
            { name: "received_at", type: "string", isOptional: true },
            { name: "dispatched_at", type: "string", isOptional: true },
            { name: "reference_no", type: "string", isOptional: true },
            { name: "sent_at", type: "string", isOptional: true },
            { name: "cancelled_at", type: "string", isOptional: true },
            { name: "due_at", type: "string", isOptional: true },
            { name: "completed_at", type: "number", isOptional: true },
            { name: "filters", type: "string", isOptional: true },
            { name: "totals", type: "string", isOptional: true },
            { name: "staff_id", type: "string", isOptional: false },
            { name: "location_id", type: "string", isOptional: false },
            {
              name: "items_last_fetch_millis",
              type: "number",
              isOptional: true,
            },
            ...baseColumns,
          ],
        }),

        createTable({
          name: "counts",
          columns: [
            { name: "inventory_movement_id", type: "string" },
            { name: "inventory_movement_item_id", type: "string" },
            { name: "adjust_by", type: "number" },
            ...syncMetaColumns,
            ...baseColumns,
          ],
        }),
      ],
    },
    {
      toVersion: 3,
      steps: [
        addColumns({
          table: "customers",
          columns: [
            {
              name: "is_retailer_cus_account",
              type: "boolean",
              isOptional: false,
            },
          ],
        }),
      ],
    },
    {
      toVersion: 4,
      steps: [
        addColumns({
          table: "sales",
          columns: [
            {
              name: "metadata",
              type: "string",
              isOptional: true,
            },
          ],
        }),
      ],
    },

    {
      toVersion: 5,
      steps: [
        addColumns({
          table: "sale_items",
          columns: [
            {
              name: "tax_rate_percent",
              type: "number",
              isOptional: true,
            },
          ],
        }),
      ],
    },

    {
      toVersion: 6,
      steps: [
        createTable({
          name: "serial_numbers",
          columns: [
            {
              name: "productLocationInventoryPricingId",
              type: "string",
              isOptional: false,
            },
            { name: "value", type: "string", isOptional: false },
            ...baseColumns,
          ],
        }),
      ],
    },

    {
      toVersion: 7,
      steps: [
        createTable({
          name: "suppliers",
          columns: [
            { name: "name", type: "string", isOptional: false },
            { name: "suppCode", type: "string", isOptional: false },
            { name: "active", type: "boolean", isOptional: false },
            ...baseColumns,
          ],
        }),
        addColumns({
          table: "products",
          columns: [
            { name: "web_description", type: "string", isOptional: true },
            { name: "price_lookup", type: "string", isOptional: true },
            { name: "weight", type: "number", isOptional: true },
            { name: "UOM", type: "string", isOptional: true },
            { name: "web_price", type: "number", isOptional: true },
            { name: "supplier_id", type: "string", isOptional: true },
            { name: "supplier_stock_code", type: "string", isOptional: true },
            { name: "tags", type: "string", isOptional: true },
          ],
        }),
      ],
    },
    {
      toVersion: 8,
      steps: [
        createTable({
          name: "stock_counts",
          columns: [
            { name: "name", type: "string" },
            { name: "status", type: "string" },
            { name: "source", type: "string" },
            { name: "retailer_stocktake_id", type: "string" },
            { name: "location_id", type: "string" },
            {
              name: "items_last_fetch_millis",
              type: "number",
              isOptional: true,
            },
            ...baseColumns,
          ],
        }),
        createTable({
          name: "stock_count_lines",
          columns: [
            { name: "barcode", type: "string" },
            { name: "status", type: "string", isOptional: true },
            { name: "product_id", type: "string", isOptional: true },
            { name: "stock_count_id", type: "string", isOptional: false },
            { name: "initial_expected", type: "number", isOptional: true },
            { name: "expected", type: "number", isOptional: true },
            ...baseColumns,
          ],
        }),
        createTable({
          name: "stock_count_items",
          columns: [
            { name: "stock_count_line_id", type: "string" },
            { name: "status", type: "string" },
            { name: "counted", type: "number" },
            { name: "counted_at", type: "number" },
            { name: "remote_id", type: "string", isOptional: true },
            ...syncMetaColumns,
            ...baseColumns,
          ],
        }),
        createTable({
          name: "tax_groups",
          columns: [
            { name: "name", type: "string", isOptional: false },
            { name: "short_name", type: "string", isOptional: true },
            { name: "arrive_percentage", type: "number", isOptional: false },
            { name: "sale_percentage", type: "number", isOptional: false },
            ...baseColumns,
          ],
        }),
        addColumns({
          table: "departments",
          columns: [{ name: "markup", type: "string", isOptional: true }],
        }),
        addColumns({
          table: "categories",
          columns: [{ name: "markup", type: "string", isOptional: true }],
        }),
        addColumns({
          table: "products",
          columns: [
            { name: "serial_numbers_arr", type: "boolean", isOptional: false },
            { name: "serial_numbers_sale", type: "boolean", isOptional: false },
          ],
        }),
      ],
    },
    {
      toVersion: 9,
      steps: [
        addColumns({
          table: "sales",
          columns: [
            { name: "quote_accepted", type: "boolean", isOptional: true },
          ],
        }),

        addColumns({
          table: "pay_types",
          columns: [
            { name: "platforms", type: "string", isOptional: false },
            { name: "channels", type: "string", isOptional: false },
          ],
        }),

        addColumns({
          table: "sale_items",
          columns: [{ name: "name", type: "string", isOptional: true }],
        }),

        addColumns({
          table: "payment_methods",
          columns: [
            { name: "retailer_pay_type_id", type: "string", isOptional: true },
          ],
        }),
        createTable({
          name: "retailer_pay_types",
          columns: [
            { name: "pay_code", type: "string", isOptional: true },
            { name: "pay_description", type: "string", isOptional: true },
            ...baseColumns,
          ],
        }),
      ],
    },
    {
      toVersion: 10,
      steps: [
        addColumns({
          table: "categories",
          columns: [
            {
              name: "preferred_tax_group_id",
              type: "string",
              isOptional: true,
            },
          ],
        }),
        addColumns({
          table: "departments",
          columns: [
            {
              name: "preferred_tax_group_id",
              type: "string",
              isOptional: true,
            },
          ],
        }),
      ],
    },
    {
      toVersion: 11,
      steps: [
        addColumns({
          table: "sale_items",
          columns: [
            {
              name: "customer_note",
              type: "string",
              isOptional: true,
            },
          ],
        }),
      ],
    },
    {
      toVersion: 12,
      steps: [
        createTable({
          name: "docket_template_types",
          columns: [
            { name: "name", type: "string", isOptional: false },
            { name: "html", type: "string", isOptional: false },
            { name: "css", type: "string", isOptional: false },
            ...baseColumns,
          ],
        }),
        createTable({
          name: "docket_templates",
          columns: [
            { name: "name", type: "string", isOptional: false },
            {
              name: "default_template_type_id",
              type: "string",
              isOptional: false,
            },
            { name: "enabled", type: "boolean", isOptional: false },
            { name: "filters", type: "string", isOptional: false },
            { name: "terminal_ids", type: "string", isOptional: false },
            { name: "automatically_print", type: "boolean", isOptional: false },
            ...baseColumns,
          ],
        }),
      ],
    },
    {
      toVersion: 13,
      steps: [
        addColumns({
          table: "sales",
          columns: [
            { name: "purchase_order_number", type: "string", isOptional: true },
          ],
        }),
      ],
    },
    {
      toVersion: 14,
      steps: [
        addColumns({
          table: "sale_items",
          columns: [
            { name: "gift_card_number", type: "string", isOptional: true },
          ],
        }),
        addColumns({
          table: "sales",
          columns: [
            { name: "gift_voucher_code", type: "string", isOptional: true },
          ],
        }),
      ],
    },
    {
      toVersion: 15,
      steps: [
        addColumns({
          table: "customers",
          columns: [
            { name: "is_trade_customer", type: "boolean", isOptional: false },
          ],
        }),
      ],
    },
    {
      toVersion: 16,
      steps: [
        addColumns({
          table: "customers",
          columns: [{ name: "retailer_id", type: "string", isOptional: true }],
        }),
      ],
    },
    {
      toVersion: 17,
      steps: [
        addColumns({
          table: "stock_count_lines",
          columns: [{ name: "name", type: "string", isOptional: true }],
        }),
      ],
    },
    {
      toVersion: 18,
      steps: [
        addColumns({
          table: "products",
          columns: [{ name: "adjustable", type: "boolean", isOptional: false }],
        }),
      ],
    },
    {
      toVersion: 19,
      steps: [
        addColumns({
          table: "sales",
          columns: [
            {
              name: "expected_pickup_date",
              type: "number",
              isOptional: true,
            },
          ],
        }),
      ],
    },
    {
      toVersion: 20,
      steps: [
        addColumns({
          table: "payment_methods",
          columns: [
            {
              name: "handler",
              type: "string",
              isOptional: true,
            },
          ],
        }),
      ],
    },
    {
      toVersion: 21,
      steps: [
        createTable({
          name: "product_kits",
          columns: [
            { name: "product_id", type: "string", isOptional: false },
            { name: "kit_id", type: "string", isOptional: false },
            { name: "description", type: "string", isOptional: true },
            ...baseColumns,
          ],
        }),
        createTable({
          name: "product_kit_items",
          columns: [
            { name: "product_kit_id", type: "string", isOptional: false },
            { name: "product_id", type: "string", isOptional: false },
            { name: "quantity", type: "number", isOptional: false },
            { name: "price", type: "number", isOptional: false },
            ...baseColumns,
          ],
        }),
        addColumns({
          table: "products",
          columns: [
            { name: "product_kit_id", type: "string", isOptional: true },
          ],
        }),
        addColumns({
          table: "sale_items",
          columns: [
            { name: "product_kit_id", type: "string", isOptional: true },
            {
              name: "is_kit",
              type: "boolean",
              isOptional: true,
            },
          ],
        }),

        addColumns({
          table: "sale_items",
          columns: [
            { name: "product_kit_id", type: "string", isOptional: true },
            {
              name: "is_kit",
              type: "boolean",
              isOptional: true,
            },
          ],
        }),
      ],
    },
    {
      toVersion: 22,
      steps: [
        addColumns({
          table: "layout_nodes",
          columns: [
            { name: "image_url", type: "string", isOptional: true },
            { name: "label_color", type: "string", isOptional: true },
          ],
        }),
      ],
    },
  ],
});
